export const get_gmail_url = (to, subject, body) => {
  return `${process.env.GMAIL_URL_BASE}&to=${to}&su=${subject}&body=${body}`
}
